module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapnamea"
  }, [_c('b', [_vm._v("TABLE OF CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/preface"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/intro"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/intro#h1"
    }
  }, [_c('i', [_vm._v("If Coaching Is Booming, Why Are So Many Coaches Struggling to Get By?")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "tocn1"
  }, [_c('a', {
    attrs: {
      "href": "#/step1"
    }
  }, [_vm._v("Step I")])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('a', {
    attrs: {
      "href": "#/step1#h1"
    }
  }, [_c('b', [_vm._v("LAY A SOLID STRATEGIC FOUNDATION")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1#h1"
    }
  }, [_c('i', [_vm._v("The Opportunity Is Greatest When You Think of Yourself as More Than a Coach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter2#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Three Requirements for Ongoing Success as a Coach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter3#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Choose a Profitable Target Market")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter4#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Understand the Needs in Your Market")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter5#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Develop Robust Coaching Solutions for Your Market")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter6#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Develop Your Compelling Marketing Message and Brand")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "tocn1"
  }, [_c('span', {
    attrs: {
      "href": "#/step2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step II")])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/step2#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("USE LOW-COST, HIGH-IMPACT TACTICS TO GET CLIENTS")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter7#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Set Up Your Testing Laboratory")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter8#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Most Powerful Tactic in Your Arsenal")]), _vm._v("—"), _c('i', [_vm._v("Conversations to Get Referrals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter9#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Alliances to Bring You a Stream of Business")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Achieve Expert Status Through Information and By Educating Your Market")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Internet Marketing Tactics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Leadership to Build Your Credibility")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Creative Strategies to Reach Top Decision Makers and VIPs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter14#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Special Report—Get That First Client")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "tocn1"
  }, [_c('span', {
    attrs: {
      "href": "#/step3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step III")])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/step3#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CLOSE ENGAGEMENTS")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter15#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Overcome Low-Pricing Self-Esteem")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter16#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Ask Questions That Engage and Assess Fit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter17#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Handle Concerns and Objections with Finesse and Grace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter18#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Strategies to Close the Deal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter19#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("How to Write a Powerful Proposal—And When Not To")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "tocn1"
  }, [_c('span', {
    attrs: {
      "href": "#/step4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step IV")])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/step4#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("KEEP CLIENTS FOR LIFE, OR AT LEAST FOR A LONG TIME")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter20#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Value of Your First Client, and Every Client Who Follows")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter21#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Deliver Value and Create Raving Fans")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter22#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("From Foothold to a Major Presence")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "tocn1"
  }, [_c('span', {
    attrs: {
      "href": "#/step5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step V")])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/step5#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("BUILD A FIRM TO ENJOY LASTING WEALTH")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter23#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Firm-Builder Mindset")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter24#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("How to Develop a Framework That Turns into Ongoing Wealth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter25#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Twelve Steps to a Successful Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Six")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter26#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Information Products to Get Up to 100 Times the Price of a Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Seven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter27#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Group-Coaching Packages, Seminars, Subscriptions, and Leadership Circles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Eight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter28#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Certify Others and/or License Your Content")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Nine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter29#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Get Bigger Engagements by Contracting With or Hiring Other Coaches and Experts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter30#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Develop Tools for Clients and for Other Coaches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-One")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter31#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Create a Center of Excellence or an Institute")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "tocn1"
  }, [_c('span', {
    attrs: {
      "href": "#/step6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Step VI")])]), _vm._v(" "), _c('p', {
    staticClass: "tocn"
  }, [_c('span', {
    attrs: {
      "href": "#/step6#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CREATE YOUR MILLION-DOLLAR BUSINESS PLAN")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter32#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Your Million-Dollar Business Model")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirty-Three")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter33#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Your Action Plan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    attrs: {
      "href": "#/conclusion#h1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Claim Your Power as a Coach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/abouttheauthor",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Authors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 78
// module chunks = 0